import { render, staticRenderFns } from "./emergencyTrainingResultAppr.vue?vue&type=template&id=036a6ea7"
import script from "./emergencyTrainingResultAppr.vue?vue&type=script&lang=js"
export * from "./emergencyTrainingResultAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036a6ea7')) {
      api.createRecord('036a6ea7', component.options)
    } else {
      api.reload('036a6ea7', component.options)
    }
    module.hot.accept("./emergencyTrainingResultAppr.vue?vue&type=template&id=036a6ea7", function () {
      api.rerender('036a6ea7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/eap/result/emergencyTrainingResultAppr.vue"
export default component.exports